import React from 'react';
import { Card, Thumbnail, token } from '@bynder/design-system';
import { IconImage, IconVideo } from '@bynder/icons';
import { PartialComponent } from 'packages/services/ComponentService';
import ComponentMenu from './ComponentMenu';

interface Props {
    component: PartialComponent;
    collectionName: string;
    onClick: (isUniqueContentProperties: boolean) => void;
}

const ComponentCard = ({ component, collectionName, onClick }: Props) => {
    return (
        <Card
            variant="clean"
            onClick={() => onClick(false)}
            contextAction={
                <ComponentMenu
                    component={component}
                    collectionName={collectionName}
                    onApply={onClick}
                    onEdit={() => {}}
                    onDelete={() => {}}
                />
            }
        >
            <Card.Frame
                badge={
                    component.type === 'IMAGE' ? (
                        <Thumbnail
                            variant="clean"
                            icon={<IconImage />}
                            iconColor={token.white}
                            backgroundColor={token.gray400a}
                        />
                    ) : (
                        <Thumbnail
                            variant="clean"
                            icon={<IconVideo />}
                            iconColor={token.white}
                            backgroundColor={token.gray400a}
                        />
                    )
                }
            >
                <Card.Images>
                    {/* TODO: Add component image */}
                    <Card.Img src={'TODO'} />
                </Card.Images>
            </Card.Frame>
        </Card>
    );
};

export default ComponentCard;
